import * as React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { ReactComponent as UploadedSVG } from '@assets/images/uploaded.svg';
import { ReactComponent as ProcessingSVG } from '@assets/images/processing.svg';
import { ReactComponent as FinishedSVG } from '@assets/images/finished.svg';

export const StageUploaded = ({
  count,
  className,
}: {
  count: number;
  className?: string;
}) => {
  const { t } = useTranslation();
  const classes = classnames('orders-stage-svg', className);
  return (
    <React.Fragment>
      <UploadedSVG className={classes} title={t('orders_stagesUploaded')} />
      <div className='orders-stage-count'>{count > 0 && count}</div>
    </React.Fragment>
  );
};

export const StageProcessing = ({
  count,
  anyPassedProcessing,
  className,
}: {
  count: number;
  anyPassedProcessing: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const classes = classnames('orders-stage-svg', className, {
    'orders-stage-gray': count < 1 && !anyPassedProcessing,
  });
  return (
    <React.Fragment>
      <ProcessingSVG className={classes} title={t('orders_stagesProcessing')} />
      <div className='orders-stage-count'>{count > 0 && count}</div>
    </React.Fragment>
  );
};

export const StageFinished = ({ count }: { count: number }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FinishedSVG
        className={`orders-stage-svg ${count < 1 ? 'orders-stage-gray' : ''}`}
        title={t('orders_stagesFinished')}
      />
      <div className='orders-stage-count'>{count > 0 && count}</div>
    </React.Fragment>
  );
};
